import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface AuditLog {
  id: number;
  user_id: number;
  action: string;
  target_type: string;
  target_id: number;
  changes: string;
  ip_address: string;
  created_at: string;
}

export function useAuditLogs() {
  return useQuery({
    queryKey: ["audit-logs"],
    queryFn: async () => {
      const res = await apiClient.get("/admin/audit-logs");
      return res.data.data as AuditLog[];
    },
  });
}
